import { Link } from 'react-router-dom'
import { SocialLinks } from './SocialLinks'
import { personalInfo, socialLinks } from '../lib/content'

export function Hero() {
  return (
    <section className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-16">
      <div className="max-w-3xl mx-auto text-center">
        {/* Name */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-slate-900 dark:text-white mb-4 animate-fade-in">
          {personalInfo.name}
        </h1>

        {/* Title */}
        <p className="text-xl sm:text-2xl text-orange-500 dark:text-orange-400 font-medium mb-6 animate-fade-in-delay-1">
          {personalInfo.title}
        </p>

        {/* Tagline */}
        <p className="text-lg sm:text-xl text-slate-600 dark:text-slate-300 mb-8 animate-fade-in-delay-2">
          {personalInfo.tagline}
        </p>

        {/* About */}
        <p className="text-slate-600 dark:text-slate-400 max-w-2xl mx-auto mb-10 leading-relaxed animate-fade-in-delay-3">
          {personalInfo.about}
        </p>

        {/* Social Links */}
        <div className="flex justify-center mb-10 animate-fade-in-delay-4">
          <SocialLinks links={socialLinks} size="lg" />
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-delay-5">
          <Link
            to="/cv"
            className="px-8 py-3 bg-orange-500 hover:bg-orange-600 text-white font-medium rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
          >
            View CV
          </Link>
          <Link
            to="/projects"
            className="px-8 py-3 border-2 border-orange-500 dark:border-orange-400 hover:bg-orange-500 dark:hover:bg-orange-400 text-orange-500 dark:text-orange-400 hover:text-white dark:hover:text-white font-medium rounded-lg transition-colors duration-200"
          >
            View Projects
          </Link>
          <a
            href={`mailto:${personalInfo.email}`}
            className="px-8 py-3 border-2 border-slate-300 dark:border-slate-600 hover:border-orange-500 dark:hover:border-orange-400 text-slate-700 dark:text-slate-300 hover:text-orange-500 dark:hover:text-orange-400 font-medium rounded-lg transition-colors duration-200"
          >
            Contact Me
          </a>
        </div>
      </div>
    </section>
  )
}
